import { Container } from "react-bootstrap";
import HeaderLanding from "../components/HeaderLanding";
import Tail from "../components/Tail";

export default function Terms() {
  return (
    <div className="d-flex flex-column min-vh-100">
      <HeaderLanding />

      <main className="flex-grow-1">
        <Container className="py-5">
          <div className="terms-content">
            <h1 className="mb-4">Terms of Use</h1>
            <p className="text-muted">Last Updated: {new Date().toLocaleDateString()}</p>

            <section className="mb-5">
              <h2 className="h4 mb-3">1. Acceptance of Terms</h2>
              <p>
                By accessing and using Pic-Loud ("Service"), you accept and agree to be bound by the terms and provision of this agreement. If you do not agree to abide by the above, please do not use this service.
              </p>
            </section>

            <section className="mb-5">
              <h2 className="h4 mb-3">2. Service Description</h2>
              <p>
                Pic-Loud is an AI-powered photo management platform designed for event organizers and photographers. Our Service includes:
              </p>
              <ul className="ms-3">
                <li>AI face recognition technology to identify participants in event photos</li>
                <li>Automatic photo delivery to participants based on facial recognition</li>
                <li>Event-based photo gallery management</li>
                <li>Selfie registration for participant identification</li>
                <li>Private personal galleries for each participant</li>
                <li>Social sharing capabilities</li>
                <li>Analytics dashboard for event organizers</li>
                <li>Monetization features for photographers</li>
              </ul>
            </section>

            <section className="mb-5">
              <h2 className="h4 mb-3">3. User Accounts</h2>
              <p>
                To use certain features of the Service, you may need to create an account. You agree to:
              </p>
              <ul className="ms-3">
                <li>Provide accurate, current, and complete account information</li>
                <li>Maintain the confidentiality of your password</li>
                <li>Accept responsibility for all activities under your account</li>
                <li>Notify us immediately of any unauthorized use of your account</li>
              </ul>
            </section>

            <section className="mb-5">
              <h2 className="h4 mb-3">4. Biometric Data &amp; Face Recognition</h2>
              <p>
                Our Service uses advanced facial recognition technology. By uploading photos or registering with a selfie, you consent to:
              </p>
              <ul className="ms-3">
                <li>Collection and processing of your face matrix (biometric data)</li>
                <li>Use of your face encoding to match photos across event galleries</li>
                <li>Storage of biometric data for the duration of your participation in events on our platform</li>
              </ul>
              <p>
                <strong>For participants in the EU:</strong> We process biometric data in accordance with GDPR Article 9 and have obtained explicit consent through the selfie registration process.
              </p>
              <p>
                You have the right to request deletion of your biometric data at any time by contacting us at support@pic-loud.com.
              </p>
            </section>

            <section className="mb-5">
              <h2 className="h4 mb-3">5. Payment &amp; Billing</h2>
              <p>
                <strong>Free Trial:</strong> We offer a free trial with limited features. Trial access is provided at no charge for the trial period specified at signup.
              </p>
              <p>
                <strong>Paid Services:</strong> If you subscribe to a paid plan:
              </p>
              <ul className="ms-3">
                <li>You authorize us to charge your payment method on a recurring basis</li>
                <li>Billing occurs on the date specified during signup</li>
                <li>You are responsible for keeping your payment information current</li>
                <li>Failed payments may result in service suspension</li>
              </ul>
            </section>

            <section className="mb-5">
              <h2 className="h4 mb-3">6. Refund Policy</h2>
              <p>
                We offer a full refund within 30 days of your subscription purchase if you are not satisfied with our Service. To request a refund, contact us at support@pic-loud.com with your subscription details.
              </p>
              <p>
                Refunds will be processed within 7-10 business days. After the 30-day period, no refunds will be issued, but you may cancel your subscription at any time.
              </p>
            </section>

            <section className="mb-5">
              <h2 className="h4 mb-3">7. User Responsibilities</h2>
              <p>
                You agree not to use the Service to:
              </p>
              <ul className="ms-3">
                <li>Upload or distribute photos without proper consent from individuals pictured</li>
                <li>Violate any applicable laws or regulations</li>
                <li>Infringe upon intellectual property rights of others</li>
                <li>Engage in harassment, abuse, or discrimination</li>
                <li>Attempt to gain unauthorized access to the Service</li>
                <li>Interfere with or disrupt the Service or its servers</li>
                <li>Reverse engineer, decompile, or attempt to derive the source code</li>
                <li>Use the Service for any illegal or unauthorized purpose</li>
              </ul>
            </section>

            <section className="mb-5">
              <h2 className="h4 mb-3">8. Intellectual Property</h2>
              <p>
                <strong>Our Content:</strong> All content, features, and functionality of the Service (including but not limited to software, code, algorithms, and designs) are owned by Pic-Loud, its licensors, or other providers and are protected by copyright, trademark, and other intellectual property laws.
              </p>
              <p>
                <strong>Your Content:</strong> You retain ownership of photos and other content you upload. By uploading content, you grant Pic-Loud a non-exclusive, worldwide, royalty-free license to use, reproduce, modify, and display your content solely for the purpose of delivering the Service.
              </p>
            </section>

            <section className="mb-5">
              <h2 className="h4 mb-3">9. Service Availability &amp; SLA</h2>
              <p>
                <strong>Uptime Guarantee:</strong> We commit to 99.9% uptime for our Service, measured on a monthly basis.
              </p>
              <p>
                <strong>Maintenance Windows:</strong> We may perform maintenance during night hours (Israel Time, typically 22:00-06:00 IL) with short downtime periods. We will endeavor to provide advance notice when possible.
              </p>
              <p>
                We do not guarantee error-free operation or that all defects will be corrected.
              </p>
            </section>

            <section className="mb-5">
              <h2 className="h4 mb-3">10. Limitation of Liability</h2>
              <p>
                TO THE FULLEST EXTENT PERMITTED BY LAW, PIC-LOUD SHALL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES, OR ANY LOSS OF PROFITS, REVENUE, DATA, OR USE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGES.
              </p>
              <p>
                OUR TOTAL LIABILITY SHALL NOT EXCEED THE AMOUNT PAID BY YOU IN THE 12 MONTHS PRECEDING THE CLAIM, OR $100, WHICHEVER IS GREATER.
              </p>
              <p>
                Some jurisdictions do not allow the exclusion or limitation of certain damages, so some of the above limitations may not apply to you.
              </p>
            </section>

            <section className="mb-5">
              <h2 className="h4 mb-3">11. Indemnification</h2>
              <p>
                You agree to indemnify, defend, and hold harmless Pic-Loud and its officers, directors, employees, and agents from any claims, damages, losses, or expenses arising from:
              </p>
              <ul className="ms-3">
                <li>Your use of the Service in violation of these Terms</li>
                <li>Your violation of any law or regulations</li>
                <li>Your infringement of third-party rights</li>
                <li>Your content or user-generated material</li>
              </ul>
            </section>

            <section className="mb-5">
              <h2 className="h4 mb-3">12. Termination</h2>
              <p>
                We reserve the right to terminate or suspend your account and access to the Service at any time, with or without cause, and with or without notice. Cause for termination includes:
              </p>
              <ul className="ms-3">
                <li>Violation of these Terms of Use</li>
                <li>Abusive or harassing behavior toward other users or staff</li>
                <li>Illegal activity</li>
                <li>Non-payment of fees</li>
              </ul>
              <p>
                Upon termination, your right to use the Service will cease immediately.
              </p>
            </section>

            <section className="mb-5">
              <h2 className="h4 mb-3">13. Modifications to Terms</h2>
              <p>
                We reserve the right to modify these Terms at any time. Continued use of the Service following notice of changes constitutes your acceptance of the revised Terms. We will notify you of significant changes via email or through the Service.
              </p>
            </section>

            <section className="mb-5">
              <h2 className="h4 mb-3">14. Governing Law &amp; Jurisdiction</h2>
              <p>
                These Terms of Use shall be governed by and construed in accordance with the laws of the State of Israel, without regard to its conflict of law provisions. Any legal action or proceeding related to these Terms shall be brought exclusively in the courts of Israel, and you consent to the personal jurisdiction of such courts.
              </p>
            </section>

            <section className="mb-5">
              <h2 className="h4 mb-3">15. Contact Information</h2>
              <p>
                For questions about these Terms of Use, please contact us at:
              </p>
              <p>
                <strong>Johann Thuillier</strong><br />
                Pic-Loud<br />
                25 Yehuda Halevi<br />
                4248025 Netanya, Israel<br />
                Email: support@pic-loud.com<br />
                Phone: +972-58-5052871
              </p>
            </section>

            <section className="mb-5">
              <h2 className="h4 mb-3">16. Entire Agreement</h2>
              <p>
                These Terms of Use, together with our Privacy Policy and any other agreements referenced herein, constitute the entire agreement between you and Pic-Loud regarding your use of the Service and supersede all prior and contemporaneous agreements.
              </p>
            </section>
          </div>
        </Container>
      </main>

      <footer className="mt-auto bg-light">
        <Container className="">
          <Tail />
        </Container>
      </footer>
    </div>
  );
}
